import React from "react";
import ReactDOM from "react-dom/client";

import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom/dist";
import { DataProvider } from "./Component/Context";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <BrowserRouter>
    <DataProvider>
      <center>
        <App />
      </center>
    </DataProvider>
  </BrowserRouter>
  // </React.StrictMode>
);

reportWebVitals();
